import {
  Box,
  Button,
  DialogActions,
  TextField,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import IconSuccess from '../../assets/message.svg';
import DefaultModal from '../../components/Modals/DefaultModal';
import { projectService } from '../../services/projectService';

interface ModalProps {
  open: boolean;
  setOpen: (e: boolean) => void;
  submit?: () => void;
  manager: string | undefined;
  projectId: number | undefined;
}

export default function MessageModal(props: ModalProps): JSX.Element {
  const handleClose = () => props.setOpen(false);
  const [reason, setReason] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  const handleSubmit = () => {
    if (reason) {
      projectService.sendProjectMessage({
        projectId: props.projectId,
        message: reason
      });
      setReason('');
      handleClose();
    } else {
      setError(true);
    }
  };

  return (
    <DefaultModal open={props.open} handleClose={handleClose}>
      <Box sx={{ px: 6 }}>
        <Box textAlign="center" mb={3}>
          <img src={IconSuccess} alt="success" />
        </Box>
        <Typography
          variant="h4"
          textAlign="center"
          sx={{ paddingX: 11 }}
          mb={2}
        >
          Send a Message to {props.manager}
        </Typography>
        <TextField
          sx={{ my: 2 }}
          required
          id="ReasonForEditing"
          multiline
          placeholder="Hello! I have a question about this project...."
          value={reason}
          error={error}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
        />
      </Box>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button
          sx={{ marginRight: '25px', paddingX: '40px' }}
          variant="outlined"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button sx={{ paddingX: '60px' }} onClick={handleSubmit}>
          Send
        </Button>
      </DialogActions>
    </DefaultModal>
  );
}
